import {openDb} from "../../../Services/BrowserDatabaseIDB";
import {ensureStoresExist} from "../../../Services/BrowserDatabaseFunctions";


export function addAccountDocument(_account_id, _document){

    return openDb('pa', 1, ensureStoresExist)
        .then(function (db) {
            const tx = db.transaction('Account', 'readwrite');
            const dataStore = tx.objectStore('Account');

            return dataStore.get('Account').then(_account => {
            //add the new Document to the documents array (if it doesn't exist)
            const documentIndex = _account.documents.findIndex(document => document.id === _document.id);

            if (documentIndex !== -1) {
                //the document already exists

            } else {
                //add the document
                _account.documents.push(_document);
            }
            return dataStore.put(_account, 'Account').then(() => {
                console.log(`Added document to Account successfully.`);
                return true;
            });
        });
    }).catch(function (error) {
        console.error("An error occurred:", error);
        throw error; // Re-throw the error to be caught by the caller
    });
}
export function updateAccountDocument(_account_id, _updated_document) {
    return openDb('pa', 1, ensureStoresExist)
        .then(function (db) {
            const tx = db.transaction('Account', 'readwrite');
            const dataStore = tx.objectStore('Account');

            // Get the Account object
        return dataStore.get('Account').then(_account => {

            if (_account.id !== _account_id) return null;

            // Make sure Account.documents exists and is an array
            if (!Array.isArray(_account.documents)) {
                _account.documents = [];
            }

            // Find and update the matching document
            const docIndex = _account.documents.findIndex(
                (doc) => doc.id === _updated_document.id
            );

            if (docIndex !== -1) {
                const patch = _updated_document;
                const base = _account.documents[docIndex];
                const merged = { ...base };
                Object.keys(patch).forEach(k => {
                    if (typeof patch[k] !== 'undefined') merged[k] = patch[k];
                });
                _account.documents[docIndex] = merged;
            } else {
                // If it doesn’t exist, add it
                _account.documents.push(_updated_document);
            }

            // Put the updated account back into the object store
            return dataStore.put(_account, 'Account').then(() => {
                console.log(`updated Account document successfully.`);
                return true;
            });
        });
    }).catch(function (error) {
        console.error("An error occurred:", error);
        throw error; // Re-throw the error to be caught by the caller
    });
}
export function deleteAccountDocument(_account_id, _document_id) {
    return openDb('pa', 1, ensureStoresExist)
        .then(function (db) {
            const tx = db.transaction('Account', 'readwrite');
            const dataStore = tx.objectStore('Account');

            // Get the Account object
        return dataStore.get('Account').then(_account => {

            if (_account.id !== _account_id) return null;

            // Filter out the document with the specified ID
            _account.documents = (_account.documents || []).filter(
                (doc) => doc.id !== _document_id
            );
            // Put the updated account back into the object store
            return dataStore.put(_account, 'Account').then(() => {
                console.log(`Deleted the Account document successfully.`);
                return true;
            });
        });
    }).catch(function (error) {
        console.error("An error occurred:", error);
        throw error; // Re-throw the error to be caught by the caller
    });
}

export function addEventDocument(_event_id, _document) {
    return openDb("pa", 1, ensureStoresExist)
        .then(function (db) {
            const tx = db.transaction("Events", "readwrite");
            const dataStore = tx.objectStore("Events");

            // Get the specific event by its id
            return dataStore.get(_event_id).then(event => {
                if (!event) {
                    console.error(`Event with ID ${_event_id} not found.`);
                    return false;
                }

                // ensure documents is an array
                const documents = Array.isArray(event.documents)
                    ? event.documents.slice()
                    : [];

                // optional: avoid duplicates by id
                const idx = documents.findIndex(d => {
                    if (!d || !_document) return false;

                    // Match by permanent ID
                    const matchId = d.id != null && _document.id != null && String(d.id) === String(_document.id);

                    // 🎯 ADD THIS: Match by temp_id
                    // This allows the finalized server doc to replace the local "Uploading..." placeholder
                    const matchTempId = d.temp_id != null && _document.temp_id != null && String(d.temp_id) === String(_document.temp_id);

                    return matchId || matchTempId;
                });

                if (idx >= 0) {
                    // merge into existing document, only defined fields
                    const base = documents[idx];
                    const patch = _document;
                    const merged = { ...base };
                    Object.keys(patch).forEach(k => {
                        if (typeof patch[k] !== "undefined") merged[k] = patch[k];
                    });
                    documents[idx] = merged;
                } else {
                    documents.push(_document);
                }

                event.documents = documents;

                const sanitizedEvent = JSON.parse(JSON.stringify(event));

                return dataStore.put(sanitizedEvent).then(() => {
                    console.log(
                        `Document with ID ${_document.id} in Event with ID ${_event_id} added/updated successfully.`
                    );
                    return true;
                });
            });
        })
        .catch(function (error) {
            console.error("An error occurred in addEventDocument:", error);
            throw error;
        });
}

export function addEventDocumentsBatch(_event_id, _documents_array) {
    return openDb("pa", 1, ensureStoresExist).then(db => {
        const tx = db.transaction("Events", "readwrite");
        const dataStore = tx.objectStore("Events");

        return dataStore.get(_event_id).then(event => {
            if (!event) return false;

            let documents = Array.isArray(event.documents) ? [...event.documents] : [];

            _documents_array.forEach(newDoc => {
                const idx = documents.findIndex(d =>
                    (d.id && newDoc.id && String(d.id) === String(newDoc.id)) ||
                    (d.temp_id && newDoc.temp_id && String(d.temp_id) === String(newDoc.temp_id))
                );

                if (idx >= 0) {
                    documents[idx] = { ...documents[idx], ...newDoc };
                } else {
                    documents.push(newDoc);
                }
            });

            event.documents = documents;
            return dataStore.put(JSON.parse(JSON.stringify(event))).then(() => true);
        });
    });
}

export function updateEventDocument(_event_id, _updated_document) {
    return openDb("pa", 1, ensureStoresExist)
        .then(function (db) {
            const tx = db.transaction("Events", "readwrite");
            const dataStore = tx.objectStore("Events");

            // Get the specific event by its id
            return dataStore.get(_event_id).then(event => {
                if (!event) {
                    console.error(`❌ Event with ID ${_event_id} not found.`);
                    return false;
                }

                const documents = Array.isArray(event.documents) ? event.documents : [];

                // 🎯 Update the specific document in the array
                event.documents = documents.map(doc =>
                    String(doc.id) === String(_updated_document.id)
                        ? { ...doc, ..._updated_document }
                        : doc
                );
                const sanitizedEvent = JSON.parse(JSON.stringify(event));

                return dataStore.put(sanitizedEvent).then(() => {
                    console.log(
                        `✅ Document ${_updated_document.id} in Event ${_event_id} updated successfully.`
                    );
                    return true;
                });
            });
        })
        .catch(function (error) {
            console.error("❌ An error occurred while updating Event document:", error);
            throw error;
        });
}

export function deleteEventDocument(_event_id, _document_id) {
    return openDb("pa", 1, ensureStoresExist)
        .then(function (db) {
            const tx = db.transaction("Events", "readwrite");
            const dataStore = tx.objectStore("Events");

            // Get the specific event by its id
            return dataStore.get(_event_id).then(event => {
                if (!event) {
                    console.error(`Event with ID ${_event_id} not found.`);
                    return false;
                }

                const documents = Array.isArray(event.documents)
                    ? event.documents
                    : [];

                // Filter out the document with the specified ID
                const updatedDocuments = documents.filter(doc => {
                    if (!doc) return false;
                    return String(doc.id) !== String(_document_id);
                });

                event.documents = updatedDocuments;

                const sanitizedEvent = JSON.parse(JSON.stringify(event));

                // Put the updated event back into the object store
                return dataStore.put(sanitizedEvent).then(() => {
                    console.log(
                        `Document with ID ${_document_id} in Event with ID ${_event_id} deleted successfully.`
                    );
                    return true;
                });
            });
        })
        .catch(function (error) {
            console.error("An error occurred in deleteEventDocument:", error);
            throw error; // Re-throw the error to be caught by the caller
        });
}
